import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class UpdateService {

	private especieSubject 		= new Subject<any>();
    private loginSubject        = new Subject<any>();
    private sugerenciaSubject   = new Subject<any>();
    private sugerenciaNuevaSubject = new Subject<any>();
    private newsSubject         = new Subject<any>();
    private dispositivoSubject  = new Subject<any>();
    private casoSubject         = new Subject<any>();
	
  	constructor() { }

	especieSeleccionada(data: any)          { this.especieSubject.next(data); }
	getEspecieObservable(): Subject<any>    { return this.especieSubject; }

    loginOk(data:any)                   { this.loginSubject.next(data); }
    getLoginObservable(): Subject<any>  { return this.loginSubject; }
    
    sugerenciasBadgeUpdated(data:number)        { this.sugerenciaSubject.next(data); }
    getSugerenciasObservable(): Subject<any>    { return this.sugerenciaSubject; }

    sugerenciaNueva(data:any)                       { this. sugerenciaNuevaSubject.next(data); }
    getSugerenciaNuevaObservable() : Subject<any>   { return this.sugerenciaNuevaSubject; }

    dispositivoUpdated(data:any)                { this.dispositivoSubject.next(data); }
    getDispositivoObservable(): Subject<any>    { return this.dispositivoSubject; }

    newsBadgeUpdated(data:any)  { this.newsSubject.next(data); }
    getNewsBadgeObservable(): Subject<any>  { return this.newsSubject; }

    casoCargado(data: any)              { this.casoSubject.next(data); }
    getCasoObservable(): Subject<any>   { return this.casoSubject; }
}